import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';
import { jobsTitle } from 'react-scale/components/pages/careers/Content';
import Positions from 'react-scale/components/pages/careers/Jobs/positions';
import DepartmentFilter from 'react-scale/components/pages/careers/Jobs/departmentFilter';
import OfficeFilter from 'react-scale/components/pages/careers/Jobs/officeFilter';

const Jobs = ({
  departments,
  offices,
  jobs,
  selectedOffice,
  handleOfficeChange,
  selectedDepartment,
  handleDepartmentChange,
  departmentFilter
}) => (
  <Section id="jobs" container={false}>
    <div className="container" id="positions">
      <SectionTitle
        overtitle={jobsTitle.overtitle}
        title={jobsTitle.title}
        theme="light"
        marginBottom={false}
      />
      <div className="sticky top-0 bg-white/80 backdrop-blur-[20px] px-6 backdrop-saturate-[180%] -translate-x-6 w-[calc(100% + 3rem)] z-10">
        <div className="flex flex-col gap-4 py-12 md:flex-row">
          <DepartmentFilter
            departments={departments}
            selectedDepartment={selectedDepartment}
            handleDepartmentChange={handleDepartmentChange}
          />
          <OfficeFilter
            offices={offices}
            selectedOffice={selectedOffice}
            handleOfficeChange={handleOfficeChange}
            departmentFilter={departmentFilter}
          />
        </div>
      </div>
      <Positions
        jobs={jobs}
        selectedDepartment={selectedDepartment}
        selectedOffice={selectedOffice}
      />
    </div>
  </Section>
);

export default Jobs;
